module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page"
  }, [_c('div', {
    staticClass: "contactinfo",
    attrs: {
      "id": "contactinfo"
    }
  }, [_c('h3', [_vm._v("Kontaktinfo")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.contact.name),
      expression: "$root.contact.name"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Fornavn / Etternavn",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.contact, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.contact_name) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.contact_name)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.contact.address),
      expression: "$root.contact.address"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Adresse",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.contact, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.contact_address) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.contact_address)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.contact.email),
      expression: "$root.contact.email"
    }],
    attrs: {
      "type": "email",
      "name": "",
      "placeholder": "E-post",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.contact_email) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.contact_email)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.contact.phone),
      expression: "$root.contact.phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Mobilnummer",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.contact.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.contact, "phone", $event.target.value)
      }, _vm.$root.getContact]
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.contact_phone) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.contact_phone)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.contact.company),
      expression: "$root.contact.company"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Firma",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.contact, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.contact_company) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.contact_company)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.request.car_id),
      expression: "$root.request.car_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Registreringsnummer",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.request.car_id)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.request, "car_id", $event.target.value)
      }, _vm.$root.getCarModel]
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.car_id) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.car_id)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$root.car.model) ? [_c('div', {
    staticClass: "car-make-and-model"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.car.brand_logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-make-and-model-details"
  }, [_c('div', {
    staticClass: "car-make-and-model-year",
    domProps: {
      "textContent": _vm._s(_vm.$root.car.year)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-make-and-model-model",
    domProps: {
      "textContent": _vm._s(_vm.$root.car.producer + ' ' + _vm.$root.car.model)
    }
  })])])] : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.request.mileage),
      expression: "$root.request.mileage"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Kilometerstand",
      "required": ""
    },
    domProps: {
      "value": (_vm.$root.request.mileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.request, "mileage", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.mileage) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.mileage)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', [_c('date-picker', {
    attrs: {
      "placeholder": "Skadedato",
      "valueType": "format",
      "disabledDate": function (date) { return date >= new Date(); }
    },
    model: {
      value: (_vm.$root.request.damage_date),
      callback: function($$v) {
        _vm.$set(_vm.$root.request, "damage_date", $$v)
      },
      expression: "$root.request.damage_date"
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.damage_date) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.damage_date)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', [_c('v-select', {
    attrs: {
      "placeholder": "Forsikringsselskap",
      "options": _vm.$root.companies,
      "menu-props": {
        closeOnClick: true,
        closeOnContentClick: true,
      }
    },
    model: {
      value: (_vm.$root.request.insurance_company),
      callback: function($$v) {
        _vm.$set(_vm.$root.request, "insurance_company", $$v)
      },
      expression: "$root.request.insurance_company"
    }
  }), _vm._v(" "), (_vm.$root.requestErrors.insurance_company) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.insurance_company)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.request.consent),
      expression: "$root.request.consent"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$root.request.consent) ? _vm._i(_vm.$root.request.consent, null) > -1 : _vm._q(_vm.$root.request.consent, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$root.request.consent,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$root.request, "consent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$root.request, "consent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$root.request, "consent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Jeg samtykker til lagring og bruk av mine personlige opplysninger.")]), _vm._v(" "), (_vm.$root.requestErrors.consent) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.consent)
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.request.consent_second),
      expression: "$root.request.consent_second"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$root.request.consent_second) ? _vm._i(_vm.$root.request.consent_second, null) > -1 : _vm._q(_vm.$root.request.consent_second, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$root.request.consent_second,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$root.request, "consent_second", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$root.request, "consent_second", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$root.request, "consent_second", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Jeg aksepterer at kostaden for taksen faktureres meg og at faktura sendes per mail til oppgitt mailadresse. Kostnaden for taksten er 500,- inkl.mva.")]), _vm._v(" "), (_vm.$root.requestErrors.consent_second) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.$root.requestErrors.consent_second)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mps-actions"
  }, [_c('button', {
    staticClass: "button primary",
    attrs: {
      "id": "gtm-inquiry-submit",
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.submitContact.apply(null, arguments)
      }
    }
  }, [_vm._v("Send forespørsel\n        ")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca4fea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Contact.vue
// module id = 104
// module chunks = 0